import {
  CORE_LOAD_SETTING_INFO_REQUEST,
  CORE_LOAD_SETTING_INFO_SUCCESS,

  CORE_CHECK_AD_REQUEST,
  CORE_CHECK_AD_SUCCESS,

  CORE_LOAD_TIMEZOZE_REQUEST,
  CORE_LOAD_TIMEZOZE_SUCCESS,
} from '../../types'

const initialState = []

export default {
  setting: (state = {}, action) => {
    switch (action.type) {
      case CORE_LOAD_SETTING_INFO_REQUEST:
        return state
      case CORE_LOAD_SETTING_INFO_SUCCESS:
        return action.payload
      default:
        return state
    }
  },
  AD: (state = {}, action) => {
    switch (action.type) {
      case CORE_CHECK_AD_REQUEST:
        return {}
      case CORE_CHECK_AD_SUCCESS:
        return action.payload
      default:
        return state
    }
  },
  timezone: (state = {}, action) => {
    switch (action.type) {
      case CORE_LOAD_TIMEZOZE_REQUEST:
        return []
      case CORE_LOAD_TIMEZOZE_SUCCESS:
        return action.payload
      default:
        return state
    }
  }
}


// WEBPACK FOOTER //
// ./src/features/setting/reducer.js